import {
  inboundShipmentIdFormat,
  purchaseOrderIdFormat,
} from "@redotech/redo-ids/ids";
import * as z from "zod";

export const linkShipmentToPurchaseOrder = {
  name: "linkShipmentToPurchaseOrder" as const,
  input: z.object({
    purchaseOrderId: purchaseOrderIdFormat.schema,
    inboundShipmentId: inboundShipmentIdFormat.schema,
  }),
  output: z.object({ success: z.boolean() }),
};
